module.exports = __webpack_public_path__ + "icon-operating-data.c9653b4aaa2bdf14dee10cfc513b12a5.png";